import React, {useState, useEffect, Fragment} from "react";
import "./index.scss";
import AutoComplete from "../../../../components/forms/autocomplete";
import AnimatedInput from "../../../../components/forms/animated_input";
import Validate from "../../../../app/validation/validation";
import {useDispatch, useSelector} from "react-redux";
import {newVehicleLead} from "../../../../redux/actions";
import {getMediaPath} from "../../../../app/functions";
import arrow from "../../../../assets/icons/slider-arrow-blue.svg";
import Select from "../../../../components/forms/select";

const CarLeadForm = (props) => {

    //import redux state
    const text = useSelector(state => state.config.Translations);
    const carLeadServerError = useSelector(state => state.config.carLeadServerError);
    const deviceState = useSelector(state => state.state.deviceState);
    const user = useSelector(state => state.config.UserData);
    const citiesArr = useSelector(state => state.config.citiesArr);
    const dispatch = useDispatch();


    // Component's state
    const [firstTry,setFirstTry] = useState(true);
    const [form, setForm] = useState({
            first_name:{
                val:"",
                valid: false,
                rules: ['not_empty'],
                errMsg: ""
            },
            last_name:{
                val:"",
                valid: false,
                rules:['not_empty'],
                errMsg:""
            },
            phone:{
                val:"",
                valid: false,
                rules:['not_empty', 'phone'],
                errMsg:""
            },
            id: {
                val:"",
                valid: false,
                rules:['not_empty', "only_numbers"],
                errMsg:""
            },
            email: {
                val: '',
                valid: false,
                rules: ['not_empty', 'email'],
                errMsg: ''
            }
    });


    const [city, setCity] = useState({
            errMsg:"",
            selected:-1,
            valid:false,
            query:"",
    });

    const [subject, setSubject] = useState({
            errMsg:"",
            selected:-1,
            valid:false,
            query:"",
    });

    const [message, setMessage] = useState({
        val: '',
        valid: false,
        rules: ['not_empty'],
        errMsg: ''
    });

    useEffect(() => {
        if(user){

            let userAddress = user.addressArr.find(address => address.default);
            let new_form = {...form};
            new_form.first_name.val = user.first_name;
            new_form.last_name.val = user.last_name;
            new_form.email.val = user.email;
            new_form.phone.val = user.phone;
            new_form.id.val = user.user_id;

            setForm(new_form);

            userAddress ? city.selected= parseInt(userAddress.city_id) : city.selected= -1;

            setCity(prevState => {
                return { ...prevState, city}
            })
        }
    }, []);


    const fieldOnChange = (e) =>{
        const val = e.target.value;
        setCity(prevState => ({...prevState, query: val}));
    };

    const showErrorMsg = (name) =>{
        return !form[name].valid && !firstTry;
    };

    const handleInputChange = (evt) =>{
        let {name, value} = evt.target;

        let validate = Validate(value, form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;

        if(name==="phone" || name=== "id"){
            if(!/^[0-9]*$/.test(value)){
                value = form[name].val;
            }
        }

        setForm({...form, [name]: {...form[name], val:value, valid:is_valid, errMsg:msg}});

    }

    const fieldOnSelected = (id, text) =>{
        setCity({...city , selected : id , errMsg : '', valid : true, query: text});
    };

    const clearFieldAutocomplete = () =>{
        setCity({...city, query: '', selected: -1});
    };

    const getCities = () =>{
        const data = citiesArr;
        let res = [];
        for(let key in data){
            res.push({text:data[key].text, id: data[key].id});
        }
        return res;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let form_valid = true;

        let newForm = {...form};

        for( let field in newForm){
            let validate = Validate(newForm[field].val, newForm[field].rules);
            let is_valid = validate.valid;
            let msg = validate.msg;

            newForm[field].valid = is_valid;
            newForm[field].errMsg = msg;

            if(is_valid === false){
                form_valid = false;
            }
        }

        if( city.selected === -1 ){
            let errorMsg = "";
            errorMsg = text["car_lead_city_error_msg"];
            form_valid = false;
            setCity({...city , errMsg:errorMsg});
        }

        //only if expert check the subject and message
        if(props.isExpert){
            if( subject.selected === -1 ){
                let errorMsg = "";
                errorMsg = text["car_lead_subject_error_msg"];
                form_valid = false;
                setSubject({...subject, errMsg:errorMsg});
            }

            if( message.val === "" ){
                let errorMsg = "";
                errorMsg = text["car_lead_message_error_msg"];
                form_valid = false;
                setMessage({...message, errMsg:errorMsg});
            }
        }

        setForm(newForm);

        setFirstTry({...firstTry, firstTry: false});


        if(form_valid){
            let payload ={};

            for (let key in form){
                payload[key] = form[key].val;
            }
            payload['city_id'] = city.selected;

            //if Dani - send subject and message
            if(props.isExpert){
                payload['subject_id'] = subject.selected;
                payload['message'] = message.val;
                payload['expert_id'] = props.data.id; // expert id - not the same data is being sent via props.data
            }else{ //if not Expert - send ad id in the payload
                payload['ad_id'] = props.data; // ad id - not the same data is being sent via props.data
            }

            dispatch(newVehicleLead(payload));
        }

    }

    //display options for the select input
    function displayOptions(){
        let options = props.data.subjects;
        let res =[];

        for(let key in options){
            res.push({id: key, text: options[key]});
        }

        return res;
    }

    const subjectSelect = (id) => {
        setSubject({...subject, selected: id, errMsg: ""});
    }

    const handleMessageInput = (e) => {
        let errorMessage = "";
        const val = e.target.value;
        if(val ){
            errorMessage = "";
        } else {
            errorMessage = text["car_lead_message_error_msg"];
        }
        setMessage({ ...message, val:val, errMsg: errorMessage});
    }

    function setRows(){
        if(deviceState === "mobile" || deviceState === "tablet"){
            return 8;
        }
        return 13;
    }

    function expertClass(){
        if(props.isExpert){
            return "expert";
        }
        return "";
    }

        return(
            <div className="car-lead-form">
                <form id='form' onSubmit={handleSubmit} className="form">
                    <div className="input-wrapper">
                        <div className={"generic-form-section " + expertClass()}>

                            <AnimatedInput className={"field first-name"}
                                           value={form.first_name.val}
                                           name={"first_name"}
                                           placeholder={text["order_smart_wallet_placeholder_first_name"]}
                                           onChange={handleInputChange}
                                           showError={showErrorMsg}
                                           errorMessage={form.first_name.errMsg}
                                           type="text"
                            />
                            <AnimatedInput className={"field last-name"}
                                           value={ form.last_name.val}
                                           name={"last_name"}
                                           placeholder={text["order_smart_wallet_placeholder_last_name"]}
                                           onChange={handleInputChange}
                                           showError={showErrorMsg}
                                           errorMessage={form.last_name.errMsg}
                                           type="text"
                            />
                            <AnimatedInput className={"field phone"}
                                           value={ form.phone.val}
                                           name={"phone"}
                                           placeholder={text["order_smart_wallet_placeholder_phone"]}
                                           onChange={handleInputChange}
                                           showError={showErrorMsg}
                                           errorMessage={form.phone.errMsg}
                                           type="text"
                                           pattern="[0-9]*"

                            />
                            <AnimatedInput className={"field email"}
                                           value={ form.email.val}
                                           name={"email"}
                                           placeholder={ text["order_smart_wallet_placeholder_email"]}
                                           onChange={handleInputChange}
                                           showError={showErrorMsg}
                                           errorMessage={form.email.errMsg}
                                           type="text"
                            />
                            <AnimatedInput className={"field user-id"}
                                           value={ form.id.val}
                                           name={"id"}
                                           placeholder={text["order_smart_wallet_placeholder_user_id"]}
                                           onChange={handleInputChange}
                                           showError={showErrorMsg}
                                           errorMessage={form.id.errMsg}
                                           type="text"
                                           pattern="[0-9]*"
                            />

                            <div className='autocomplete-container'>
                                <AutoComplete className="auto-field cities-autocomplete"
                                              placeholder={text['add_form_city']}
                                              options={getCities()}
                                              onSelect={(id, text) => fieldOnSelected(id, text, 'city')}
                                              query={city.query}
                                              onChange={(e) => fieldOnChange(e, 'city')}
                                              onClear={() => clearFieldAutocomplete('city')}
                                              selected_id={city.selected}
                                />
                                <span className='err-span'>{city.errMsg}</span>
                            </div>
                        </div>

                        {props.isExpert &&
                            <Fragment>
                                <div className="expert-section-wrapper">
                                    <div className="select-subject-wrapper">
                                        <Select placeholder = {text['car_lead_select_subject']}
                                                options={displayOptions()}
                                                deviceState='desktop'
                                                arrow={getMediaPath(arrow)}
                                                className='subject'
                                                onChange={subjectSelect}
                                        />
                                        <span className='err-span'>{subject.errMsg}</span>
                                    </div>

                                    <div className="textarea-wrapper">
                                        <textarea className="textarea-class"
                                                  rows={setRows()}
                                                  cols="30"
                                                  value={message.val}
                                                  onChange={(e)=>handleMessageInput(e)}
                                                  placeholder={text["car_lead_message_placeholder"]}>
                                        </textarea>
                                        <span className='err-span'>{message.errMsg}</span>
                                    </div>
                                </div>
                            </Fragment>
                        }

                    </div>

                    <button type="submit" className="submit-btn">{text["car_lead_send_button"]}</button>
                    <span className='server-err'>{carLeadServerError}</span>
                </form>
            </div>
        );

}

export default CarLeadForm;
